module.exports = __webpack_public_path__ + "img/plant.bfab03ae.svg";